const PAYMENT_STATUS_REACT_OPENER_KEY = 'paymentStatusReactOpener';

export const markPaymentStatusReactOpener = () => {
  if (typeof window === 'undefined') return;

  window.localStorage.setItem(PAYMENT_STATUS_REACT_OPENER_KEY, '1');
};
